export default "__VITE_ASSET__6a68c340__"